import { Routes } from '@app/constants/routes';

import { useTypedParams } from '@app/router';

export const AdminProfile = () => {
  const { id } = useTypedParams(Routes.admin.user_management.admin_profile);
  return <div>Admin: {id}</div>;
};
